import { generatePath } from 'react-router-dom'

import { BonusPromotionStatus } from 'shared/models/Promotion'

import { ChoiceOfSport } from 'components/SportModal/types'

export enum MODAL_ROUTE_PATH {
  SEARCH_SLOTS = '/search-slots',
  FORGOT_PASSWORD = '/forgot-password',
  SIGN_UP_WITH_PROMOCODE = '/sign-up/:promocode',
  DEPOSIT = '/deposit/:paymentSystem',
  WITHDRAWAL = '/withdrawal/:payoutSystem',
  WHEEL_GAME = '/wheel-game',
  WHEEL_GAME_HISTORY = '/wheel-game-history',
  RESEND_EMAIL = '/resend-email',
  VERIFY_EMAIL = '/verify-email',
  CHOOSE_SPORT = '/choose-sport/:type',
  RESET_PASSWORD = '/recovery-password',
  RESET_PASSWORD_CONFIRM = '/emails/verify/password/confirm/:token',
  SIGN_IN = '/sign-in',
  SIGN_UP = '/sign-up',
  SET_LANGUAGE = '/set-language',
  PROFILE = '/profile/:tab',
  PROMOTIONS = '/promotions',
  FREE_SPIN_MODAL = '/free-spin-modal/:path',
  FREE_SPINS_OVER = '/free-spins-over',
  CONFIRM_ACTIVATE_BONUS = '/confirm-activate-bonus/:id',
}

export const MODAL_ROUTE_URLS = {
  PROFILE: (tab: string) => generatePath(MODAL_ROUTE_PATH.PROFILE, { tab }),
  VERIFY_EMAIL: () => generatePath(MODAL_ROUTE_PATH.VERIFY_EMAIL),
  SEARCH_SLOTS: () => generatePath(MODAL_ROUTE_PATH.SEARCH_SLOTS),
  FORGOT_PASSWORD: () => generatePath(MODAL_ROUTE_PATH.FORGOT_PASSWORD),
  DEPOSIT: (paymentSystem: string) => generatePath(MODAL_ROUTE_PATH.DEPOSIT, { paymentSystem }),
  WITHDRAWAL: (payoutSystem: string) => generatePath(MODAL_ROUTE_PATH.WITHDRAWAL, { payoutSystem }),
  RESET_PASSWORD: (uid: string, token: string) => generatePath(MODAL_ROUTE_PATH.RESET_PASSWORD, { uid, token }),
  WHEEL_GAME: () => generatePath(MODAL_ROUTE_PATH.WHEEL_GAME),
  WHEEL_GAME_HISTORY: () => generatePath(MODAL_ROUTE_PATH.WHEEL_GAME_HISTORY),
  RESEND_EMAIL: () => generatePath(MODAL_ROUTE_PATH.RESEND_EMAIL),
  // BUYER_ORDER: (id: string) => generatePath(ROUTE_PATHS.BUYER_ORDER, { id }),
  CHOOSE_SPORT: (type: ChoiceOfSport) => generatePath(MODAL_ROUTE_PATH.CHOOSE_SPORT, { type }),
  RESET_PASSWORD_CONFIRM: (token: string) => generatePath(MODAL_ROUTE_PATH.RESET_PASSWORD_CONFIRM, { token }),
  SIGN_IN: () => generatePath(MODAL_ROUTE_PATH.SIGN_IN),
  SIGN_UP: () => generatePath(MODAL_ROUTE_PATH.SIGN_UP),
  SET_LANGUAGE: () => generatePath(MODAL_ROUTE_PATH.SET_LANGUAGE),
  PROMOTIONS: (status?: BonusPromotionStatus) => {
    const path = generatePath(MODAL_ROUTE_PATH.PROMOTIONS)
    return status ? `${path}?status=${status}` : path
  },
  FREE_SPIN_MODAL: (path: string) => generatePath(MODAL_ROUTE_PATH.FREE_SPIN_MODAL, { path }),
  FREE_SPINS_OVER: () => generatePath(MODAL_ROUTE_PATH.FREE_SPINS_OVER),
  CONFIRM_ACTIVATE_BONUS: (id: string) => generatePath(MODAL_ROUTE_PATH.CONFIRM_ACTIVATE_BONUS, { id }),
}
